var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivestocktypeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.938,
    height: 13.094,
    viewBox: "0 0 9.938 13.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "steak",
    transform: "translate(-15.83 -4.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60941",
    "data-name": "Group 60941",
    transform: "translate(16.413 5.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87769",
    "data-name": "Path 87769",
    d: "M20.4,13.74c-.064.028-.176.057-.269.1a.167.167,0,0,1-.23-.1,2.329,2.329,0,0,1-.064-.65,4.424,4.424,0,0,1,1.092-3.028A3.466,3.466,0,0,1,23.99,9a4.468,4.468,0,0,1,.87.236c.122.045.246.084.292.217a.757.757,0,0,1-.044.43,1.66,1.66,0,0,1-.957,1.056,2.334,2.334,0,0,1-.586.195.636.636,0,0,1-.228-.01,1.385,1.385,0,0,0-1.181.233,1.2,1.2,0,0,0-.487.753c-.049.3.019.6-.16.874a1.841,1.841,0,0,1-.653.531C20.708,13.595,20.555,13.67,20.4,13.74Z",
    transform: "translate(-19.836 -8.957)",
    fill: "#86899b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60942",
    "data-name": "Group 60942",
    transform: "translate(16.932 10.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87770",
    "data-name": "Path 87770",
    d: "M27.919,40.8a5.123,5.123,0,0,1,.471,3.16c-.028.612-.065,1.226-.148,1.832a1.734,1.734,0,0,1-.454,1.194,1.031,1.031,0,0,1-.471.175,4.2,4.2,0,0,1-2.289-.282,2.651,2.651,0,0,1-.939-.649A2.445,2.445,0,0,1,23.6,45.2a2.23,2.23,0,0,1,.039-1.316,3.412,3.412,0,0,0,.3-1.274,3.192,3.192,0,0,0-.238-1.3c-.039-.095-.083-.189-.131-.281a1.345,1.345,0,0,1-.157-.291c-.035-.151.1-.281.186-.387a1.494,1.494,0,0,1,1-.576,5.431,5.431,0,0,1,1.341.147,5.406,5.406,0,0,1,1.3.291,1.635,1.635,0,0,1,.679.593Z",
    transform: "translate(-23.411 -39.762)",
    fill: "#86899b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60943",
    "data-name": "Group 60943",
    transform: "translate(21.149 6.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87771",
    "data-name": "Path 87771",
    d: "M55.86,17.813a5.336,5.336,0,0,1,.576,2.583A7.554,7.554,0,0,1,55.9,23.3q-.135.338-.3.662a7.341,7.341,0,0,1-1.7,2.173c-.121.1-.308.266-.43.065a.694.694,0,0,1-.07-.224,3.656,3.656,0,0,1-.052-.724c0-.62.061-1.24.121-1.857a7.684,7.684,0,0,0,.1-1.208,5.7,5.7,0,0,0-.6-2.059c-.116-.252-.25-.5-.361-.75a2.074,2.074,0,0,1-.119-1.456,2.933,2.933,0,0,1,.558-.909,2.091,2.091,0,0,1,.743-.669c.189-.09.348-.169.54-.042a6.326,6.326,0,0,1,.631.48,4.119,4.119,0,0,1,.9,1.031Z",
    transform: "translate(-52.406 -16.236)",
    fill: "#86899b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60944",
    "data-name": "Group 60944",
    transform: "translate(15.83 4.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87772",
    "data-name": "Path 87772",
    d: "M25.431,8.623a5.122,5.122,0,0,0-2.256-2.57A5.684,5.684,0,0,0,19.592,5a4.046,4.046,0,0,0-2.878,1.723,5.192,5.192,0,0,0-.867,3.352,1.683,1.683,0,0,0,.269.833,5.092,5.092,0,0,1,.526.784,2.65,2.65,0,0,1,.14,1.837,6.209,6.209,0,0,0-.281.9,3.257,3.257,0,0,0,.025,1.015,3.008,3.008,0,0,0,.694,1.493A4.128,4.128,0,0,0,20.2,18.072a4.027,4.027,0,0,0,.96-.112A5.428,5.428,0,0,0,24.026,15.9a8.155,8.155,0,0,0,1.581-3.449,7.623,7.623,0,0,0-.176-3.823ZM22.511,17a4.009,4.009,0,0,1-3.422.65,3.793,3.793,0,0,1-1.19-.519,2.387,2.387,0,0,1-.969-1.28,2.7,2.7,0,0,1-.048-1.773,3.191,3.191,0,0,0,.254-1.751,2.914,2.914,0,0,0-.27-.833,5.411,5.411,0,0,0-.494-.721,2.533,2.533,0,0,1-.218-1.7A4.56,4.56,0,0,1,17.5,6.26a3.756,3.756,0,0,1,3.093-.953,5.829,5.829,0,0,1,1.736.6,7.921,7.921,0,0,1,1.5.979,4.4,4.4,0,0,1,1.1,1.286,5,5,0,0,1,.486,1.741,8.135,8.135,0,0,1,.061.922A7.781,7.781,0,0,1,22.511,17Z",
    transform: "translate(-15.83 -4.978)",
    fill: "#86899b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60945",
    "data-name": "Group 60945",
    transform: "translate(18.725 8.005)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4796",
    "data-name": "Ellipse 4796",
    cx: 0.948,
    cy: 0.948,
    r: 0.948,
    transform: "translate(0 0)",
    fill: "#86899b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivestocktypeicon);
export default __webpack_public_path__ + "static/media/livestocktypeicon.0e40be4f6474c10f56326b6be6dec5a2.svg";
export { ForwardRef as ReactComponent };